// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import TestimonialCarouselController from "./testimonial_carousel_controller"
application.register("testimonial-carousel", TestimonialCarouselController)

import ImageCarouselController from "./image_carousel_controller"
application.register("image-carousel", ImageCarouselController)

import ContentEditorController from "./content_editor_controller"
application.register("content-editor", ContentEditorController)

import WorkspaceCarouselController from "./workspace_carousel_controller"
application.register("workspace-carousel", WorkspaceCarouselController)

import ScrollHeaderController from "./scroll_header_controller"
application.register("scroll-header", ScrollHeaderController)
